import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_GETDOCTORCV_FULFILLED = "FETCH_GETDOCTORCV_FULFILLED";
export const FETCH_GETDOCTORCV_REJECTED = "FETCH_GETDOCTORCV_REJECTED";
export const FETCH_GETDOCTORCV_PENDING = "FETCH_GETDOCTORCV_PENDING";
export const RESET = "RESET";


export function getDoctorCv(doctorId) {

    const data = {
        doctorId: doctorId,
    }
    const jsonData = JSON.stringify(data)
    return dispatch => {
        dispatch({
            type: "FETCH_GETDOCTORCV",
            payload: axios({
                method: "post",
                url: `https://apiv2.recallrise.com/api/doctorcv/get`,
                headers: {
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
                data: jsonData,
            }).then((result) => result.data),
        });
    };
}

export function resetDoctorCv() {
    return (dispatch) => {
        dispatch({
            type: "RESET",
        });
    };
}